import { gql } from '@apollo/client'

export const DELETE_HUMAN_RESOURCES_ATTACHMENT_BY_ID = gql`
  mutation DeleteHumanResourcesAttachmentById($id: Int!) {
    deleteHumanResourcesAttachmentById(id: $id)
  }
`